import Vue from 'vue'
import Vuex from 'vuex'
import db from './config/FirebaseInit'
import firebase from 'firebase/app';
import router from './router'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        items: {},
        products: {},
        starterplanproducts: {},
        offers: {},
        shops: {},
        topshops: [],
        searchResults: {},
        searchLocation: '',
        searchParam: '',
        serVisits: '',
        searchServicesCat: '',
        searchServicesParam: '',
        searchServicesLocation: '',
        cartItems: {},
        secondaryApp: {},
        secondaryDatabase: {},
        users: [],
        customers: [],
        viewedCustPage: false,
        suppliers: [],
        viewedSupplierPage: false,
        stores: [],
        selectedStore: '',
        prdNameList: [],
        categories:{},
        systemUser: {
            isLogedIn: false,
            role: "",
            name: "",
            id: "",
            stores: [],
            permissions: []
        },
        allProducts: [],
        noDB: '',
        plan: '',
        // broadcastChannel: '',
        // isOriginalTab: true,
        permissionsList: [
        "dashboard",
        "analytics",
        "invoice list",
        "invoice write",
        "invoice return",
        "GRN list",
        "GRN return",
        "GRN write",
        "quotation list",
        "quotation write",
        "cash flow",
        "expenses",
        "suppliers",
        "customers",
        "users",
        "online store",
        "stores",
        "settings",
        "products",
        "categories",
      ],
      starterPlanPermissionsList: [
        "dashboard",
        "analytics",
        "invoice list",
        "invoice write",
        "invoice return",
         "users",
        "online store",
        "stores",
        "settings",
        "products",
        "categories",
      ],

    },
    mutations: {
        getAppConfig(state, storename) {
            // try{
            //     firebase.app(storename)
            //     state.secondaryDatabase = firebase.app(storename).firestore()
            //     console.log('secondaryDB Exsits', state.secondaryDatabase)
            // }catch(err){
            // db.collection('shops').where('owner', '==', storename).onSnapshot(querySnapshot => {
            //     var shops = []
            //     querySnapshot.forEach(doc => {
            //     const data = {
            //     'id' : doc.id,
            //     'shoptype' : doc.data().shoptype,
            //     'visits': doc.data().visits,
            //     'loc': doc.data().location,
            //     'categories':doc.data().categories,
            //     'plan':doc.data().plan,
            //     'cat': doc.data().cat,
            //     'details': doc.data().details,  
            //     'config': doc.data().config

            //     }
            //     shops.push(data)
            //     console.log(shops[0].config)
            //     console.log(shops[0].id)
            //     var secondaryAppConfig = shops[0].config
            //      var secondary = firebase.initializeApp(secondaryAppConfig, storename)
            //     state.secondaryDatabase = secondary.firestore()
            //     // this.$store.state.secondaryApp = this.$route.params.storename
            //     state.secondaryDatabase.settings({timestampsInSnapshots: true,})
            //     state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
            //         //console.log("Woohoo! Multi-Tab Persistence!");
            //     });
            //     console.log('secondaryDB', state.secondaryDatabase)
            //     })
            //     })
            // }
        }
    },
    actions: {
    },
    getters: {
        // getItems: (state) => (cat) => {
        //     db.collection('products').where("owner", "==", firebase.auth().currentUser.uid)
        //     .where('cat', '==', cat).get()
        //     .then(querySnapshot => {
        //        var  newitems = []
        //       querySnapshot.forEach(doc => {
        //         // console.log('this.items.length is', state.items.length)
        //         const data = {
        //           'id' : doc.id,
        //           'name': doc.data().name,
        //           'category': doc.data().cat,
        //           'brand': doc.data().brand,
        //           'price': doc.data().disprice,
        //           'subcategory': doc.data().subcat,
        //           'desc': doc.data().desc,
        //           // 'img': doc.data().img,
        //           // 'otherimgs': doc.data().otherimgs,
        //         }
        //          newitems.push(data)
        //         state.items[cat] = newitems
        //         console.log('state.items[cat]',state.items[cat]) 
        //       })

        //       console.log('newitems', newitems)
        //       console.log('state.items',state.items)

        //     })
        //     return state.items[cat]
        // }
    },
})


// WEBPACK FOOTER //
// ./src/Store.js